/**
 * Season Configuration Core
 *
 * Central source of truth for all season-specific data.
 * Update this file annually to reflect the new season.
 *
 * CURRENT SEASON: 2027
 */

import type { SeasonConfig } from './types';

/**
 * Core season configuration for 2027
 *
 * This is the single source of truth for all season-specific data.
 * All dates, deadlines, and pricing are defined here.
 */
export const SEASON_CONFIG: SeasonConfig = {
  application: {
    status: {
      isOpen: false,
      message: "Applications for the 2027 season open November 15, 2026.",
      note: "Fees and tuition amounts shown are from our most recent season. Final information for the 2027 season will be posted when applications open."
    },
    deadlines: {
      start: "2026-11-15",
      phases: [
        {
          deadline: "2026-11-15",
          label: "Submit by November 15, 2026",
          fees: {
            student: 50,
            fellowship: 75
          }
        },
        {
          deadline: "2027-01-01",
          label: "Submit by January 1, 2027",
          fees: {
            student: 75,
            fellowship: 100
          }
        },
        {
          deadline: "2027-03-01",
          label: "After January 1, 2027",
          fees: {
            student: 100,
            fellowship: 125
          }
        }
      ]
    }
  },
  festival: {
    season: {
      year: 2027,
      number: 16,
      fullSession: {
        dates: "June 28 – August 8, 2027",
        arrival: {
          date: "June 28, 2027",
          time: "2:00 PM"
        },
        departure: {
          date: "August 8, 2027",
          time: "10:00 AM"
        }
      },
      sessions: [
        {
          id: 1,
          name: "Session 1",
          dates: "June 28 – July 18, 2027"
        },
        {
          id: 2,
          name: "Session 2",
          dates: "July 19 – August 8, 2027"
        }
      ],
      concerts: {
        opening: {
          date: "July 4, 2027",
          time: "7:00 PM",
          title: "AMF Orchestra Opening Concert"
        },
        closing: {
          date: "August 7, 2027",
          time: "7:00 PM",
          title: "AMF Orchestra Season Finale"
        }
      }
    },
    tuition: {
      fullSession: {
        student: 8700,
        fellowship: "Full Coverage",
        duration: "6 weeks",
        notes: [
          "Complete program participation required",
          "No late arrivals or early departures"
        ]
      },
      singleSession: {
        student: 4950,
        fellowship: "Not Available",
        duration: "3 weeks",
        notes: [
          "Choose one session period"
        ]
      },
      additionalFees: {
        registration: {
          student: 925,
          fellowship: 750,
          note: "Applied to final tuition (students) or refundable upon completion (fellows)"
        },
        comprehensive: {
          student: 350,
          fellowship: 350,
          note: "Covers event insurance and administrative costs"
        },
        damage: {
          student: 500,
          fellowship: "Included in registration",
          note: "Refundable after successful program completion"
        }
      }
    }
  }
} as const;
